import React, { useState } from 'react';
import { FDPaper, FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  InvestorEligibilityAlert,
} from 'Views/Page/Content/Templates/InvestorProfilePageTemplate/InvestorProfileSections/InvestorEligibilityAlert';

const InvestorProfileSectionDisplay = ({ resource }) => {
  const { displaySuccess, displayErrorMessage } = useSnackbarContext();
  const { onSubmit } = useMetaLayoutContext();
  const [dirty, setDirty] = useState(false);

  const handleSubmit = async () => {
    try {
      await onSubmit();
      setDirty(false);
      displaySuccess(`${resource.attr('title')} updated`);
    } catch (err) {
      displayErrorMessage(err, `Error updating ${resource.attr('title')} section`);
    }
  };

  return (
    <FDPaper appearance={'flat'} padding={400} width={'100%'} flex={1}>
      <FDStack direction={'column'} spacing={2} height={'100%'}>
        <MetaControlField attr={'title'} />
        <InvestorEligibilityAlert resource={resource} />
        <FDStack justifyContent={'flex-end'} height={'100%'} direction={'column'}>
          <MetaControlField
            attr={'memberEnrolled'}
            alwaysDirty
            fullWidth
            onChange={() => setDirty(true)}
          />
          <FDStack padding={2} direction={'column'} spacing={2}>
            <MetaControlField
              attr={'notInterestedReason'}
              alwaysDirty
              fullWidth
              onChange={() => setDirty(true)}
            />
            <FDPrimaryActionButton disabled={!dirty} onClick={handleSubmit} label={'Save'} isFullWidth={false} />
          </FDStack>
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

InvestorProfileSectionDisplay.defaultProps = {};

InvestorProfileSectionDisplay.propTypes = {
  resource: PropTypes.object.isRequired,
};


export default InvestorProfileSectionDisplay;
